import { createContext, useContext } from 'react'

import { CashierSessionModel } from '@models/cashierSession'

type CashierSessionContextProps = {
  cashierSession: CashierSessionModel | undefined
  hasCashierSession: boolean
  isLoading: boolean
  isFetching: boolean
  refetchCashierSession: () => void
}

const CashierSessionContext = createContext<CashierSessionContextProps>({
  cashierSession: undefined,
  hasCashierSession: false,
  isLoading: false,
  isFetching: false,
  refetchCashierSession: () => null,
})

const useCashierSession = () => useContext(CashierSessionContext)

export { CashierSessionContext, useCashierSession }
